import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-decisions',
  templateUrl: './workflow-decisions.component.html',
  styleUrls: ['./workflow-decisions.component.scss']
})
export class WorkflowDecisionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
